/* eslint-disable no-console */
import { fromJS } from 'immutable';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

export function onIssuesLoading(state, { meta }) {
  const claimId = get(meta, ['claimId']);

  if (!claimId) {
    console.warn('[onIssuesLoading] ClaimId is undefined');

    return state;
  }

  return state.setIn(
    ['issues', claimId],
    fromJS({ isLoaded: false, isDirty: false, value: undefined }),
  );
}

export function onIssuesLoadingErrored(state, { meta }) {
  const claimId = get(meta, ['claimId']);

  if (!claimId) {
    console.warn('[onIssuesLoadingErrored] ClaimId is undefined');

    return state;
  }

  // TODO errors
  return state.updateIn(['issues', claimId], (oldValue) =>
    oldValue.setIn(['isDirty'], true).setIn(['hasErrors'], true),
  );
}

export function onIssuesLoaded(state, { payload, meta }) {
  const claimId = get(meta, ['claimId']);
  const issues = orderBy(
    get(payload, ['value']),
    ['displayOrder', 'name'],
    ['asc', 'asc'],
  );

  if (!claimId) {
    console.warn('[onIssuesLoaded] ClaimId is undefined.');

    return state;
  }

  return state.setIn(
    ['issues', claimId],
    fromJS({ isLoaded: true, isDirty: false }).setIn(['value'], issues),
  );
}

export function onIssueSelected(state, { payload, meta }) {
  const claimId = get(meta, ['claimId']);
  const claim = get(payload, ['value']);

  if (!claimId) {
    console.warn('[onIssueSelected] ClaimId is undefined.');

    return state;
  }

  return state
    .updateIn(['claims', claimId], fromJS({}), (oldValue) =>
      fromJS({ isLoaded: true, isDirty: false }).setIn(['value'], {
        ...oldValue.get('value'),
        ...claim,
      }),
    )
    .setIn(['reasons', claimId], fromJS({ isLoaded: false, isDirty: false }))
    .setIn(['solutions', claimId], fromJS({ isLoaded: false, isDirty: false }))
    .removeIn(['claimUploads', claimId]);
}
